import type ReportingUiScopeMathsSkillsMasteredCohortRoute from 'teacher-ui-client/reporting/ui-scope/maths/skills-mastered/cohort/route'
import { t } from 'ember-intl'
import { ReportingTeacherUiHeader } from 'teacher-ui-client/components/reporting/teacher-ui-header'
import { ReportingControls } from 'teacher-ui-client/components/reporting/controls'
import { ReportingControlsGap } from 'teacher-ui-client/components/reporting/controls-gap'
import { ReportingUiScopeSelect } from 'teacher-ui-client/components/reporting/ui-scope-select'
import { ReportingPeriodSelect } from 'teacher-ui-client/components/reporting/period-select'
import { ReportingExportSelect } from 'teacher-ui-client/components/reporting/export-select'
import { StudentSearchComponent } from 'teacher-ui-client/components/student-search'
import RouteTemplate from 'ember-route-template'
import Component from '@glimmer/component'
import { service } from '@ember/service'
import type RouterService from '@ember/routing/router-service'
import { exportOptionsFromRouteInfo } from 'teacher-ui-client/utils/routing'

interface Signature {
  Args: {
    model: ModelFor<ReportingUiScopeMathsSkillsMasteredCohortRoute>
  }
}
export class ReportingUiScopeMathsSkillsMasteredCohortPage extends Component<Signature> {
  @service router!: RouterService

  get exportOptions() {
    return exportOptionsFromRouteInfo(this.router.currentRoute)
  }

  <template>
    <ReportingTeacherUiHeader @title={{t "reporting.pageTitles.skillsMastered"}} />

    <ReportingControls>
      <ReportingUiScopeSelect class="shrink basis-80" />
      <ReportingControlsGap />
      <ReportingPeriodSelect />
      <ReportingExportSelect @exportOptions={{this.exportOptions}} />
      <ReportingControlsGap />
      <StudentSearchComponent
        @studentRouteName="reporting.ui-scope.maths.student-summary.table"
        @students={{@model.scopedStudents}}
        @includeSelectAll={{false}}
      />
    </ReportingControls>

    {{outlet}}
  </template>
}

export default RouteTemplate(ReportingUiScopeMathsSkillsMasteredCohortPage)
